<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Regra de acordo
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Level"
                v-model="agreementRuleForm.get('levelId').value"
                :errors="agreementRuleForm.get('levelId').errors"
                :options="debtAgreementRules.levels"
              />
            </div>
            <div class="col-md-6">
              <select-field
                label="Tipo de divída"
                v-model="agreementRuleForm.get('debtType').value"
                :errors="agreementRuleForm.get('debtType').errors"
                :options="debtAgreementRules.debt_types"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Tipo de acordo"
                v-model="agreementRuleForm.get('agreementType').value"
                :errors="agreementRuleForm.get('agreementType').errors"
                :options="debtAgreementRules.agreement_types"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="Obrigatório entrada de"
                v-model="agreementRuleForm.get('admissionPercentage').value"
                :errors="agreementRuleForm.get('admissionPercentage').errors"
                :type="'number'"
                input-group-text-append="%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Isenção de juros e multa"
                v-model="agreementRuleForm.get('exemptChargesType').value"
                :errors="agreementRuleForm.get('exemptChargesType').errors"
                :options="debtAgreementRules.exempt_charges_types"
              />
            </div>
            <div class="col-md-6">
              <select-field
                label="Permite Reacordo"
                v-model="agreementRuleForm.get('allowsRedoAgreements').value"
                :errors="agreementRuleForm.get('allowsRedoAgreements').errors"
                :options="debtAgreementRules.allows_redo_agreements"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Condição para a quantidade de bills"
                v-model="agreementRuleForm.get('concessionRule').value"
                :errors="agreementRuleForm.get('concessionRule').errors"
                :options="debtAgreementRules.concession_rules"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="Quantidade de bills"
                v-model="agreementRuleForm.get('concessionValue').value"
                :errors="agreementRuleForm.get('concessionValue').errors"
                :type="'number'"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <select-field
                label="Aging da dívida"
                v-model="agreementRuleForm.get('debtAging').value"
                :errors="agreementRuleForm.get('debtAging').errors"
                :options="debtAgreementRules.debt_agings"
              />
            </div>
            <div class="col-md-6">
              <select-field
                label="Especificações da parcela"
                v-model="agreementRuleForm.get('installmentsType').value"
                :errors="agreementRuleForm.get('installmentsType').errors"
                :options="debtAgreementRules.installments_types"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field
                label="Quantidade de parcelas a fazer"
                v-model="agreementRuleForm.get('installmentsLimit').value"
                :errors="agreementRuleForm.get('installmentsLimit').errors"
                :type="'number'"
              />
            </div>
            <div class="col-md-6">
              <money-field
                label="Valor mínimo"
                v-model="agreementRuleForm.get('minimumAmount').value"
                :errors="agreementRuleForm.get('minimumAmount').errors"
                @input="checkMinAmountLowerThanMaxAmount()"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <money-field
                label="Valor máximo"
                v-model="agreementRuleForm.get('maximumAmount').value"
                :errors="agreementRuleForm.get('maximumAmount').errors"
                @input="checkMinAmountLowerThanMaxAmount()"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="Multa"
                v-model="agreementRuleForm.get('penaltyPercentage').value"
                :errors="agreementRuleForm.get('penaltyPercentage').errors"
                :type="'number'"
                input-group-text-append="%"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field
                label="Desconto"
                v-model="agreementRuleForm.get('discountPercentage').value"
                :errors="agreementRuleForm.get('discountPercentage').errors"
                :type="'number'"
                input-group-text-append="%"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="Validade do acordo em dias"
                v-model="agreementRuleForm.get('expiryDays').value"
                :errors="agreementRuleForm.get('expiryDays').errors"
                :type="'number'"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <textarea-field
                label="Observações"
                v-model="agreementRuleForm.get('observations').value"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="createAgreementRule()">
            Criar regra
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  InputField, SelectField, TextareaField, MoneyField,
} from 'components/form';
import { FormGroup } from 'utils/form';
import DebtAgreementRulesService from 'services/DebtAgreementRulesService';

export default {
  components: {
    InputField,
    SelectField,
    TextareaField,
    MoneyField,
  },
  data() {
    return {

      debtAgreementRules: {
        levels: [],
        allows_redo_agreements: [
          { value: true, label: 'Sim' },
          { value: false, label: 'Não' },
        ],
      },
      agreementRuleForm: new FormGroup({
        institutionId: {},
        levelId: {},
        debtType: {},
        agreementType: { required: true },
        admissionPercentage: { greaterThan: 0, lowerThan: 101 },
        exemptChargesType: {},
        allowsRedoAgreements: { value: true },
        concessionRule: {},
        concessionValue: {
          greaterThan: 0,
          lowerThan: 11,
          requiredIfMatch: { concessionRule: { values: [null, undefined, ''], condition: '!' } },
        },
        debtAging: {},
        installmentsType: {},
        installmentsLimit: { greaterThan: 0 },
        minimumAmount: { greaterThan: 0, lowerThan: 2001 },
        maximumAmount: { greaterThan: 199, lowerThan: 2301 },
        penaltyPercentage: { greaterThan: 0, lowerThan: 101 },
        discountPercentage: { greaterThan: 0, lowerThan: 21 },
        expiryDays: { greaterThan: 0 },
        observations: {},
      }),
    };
  },
  computed: {
    ...mapState([
      'institution',
    ]),
    installmentsTypeIsInstitutionEval() {
      return this.agreementRuleForm.getValue('installmentsType') === 'institution_evaluation';
    },
  },
  mounted() {
    this.agreementRuleForm.addValues({ institutionId: this.institution.id });
    this.$loader.show();
    this.loadEnumsDebtAgreementRules()
      .then((debtAgreementRules) => {
        this.debtAgreementRules = { ...this.debtAgreementRules, ...debtAgreementRules };
        return this.loadLevels();
      })
      .then((levels) => {
        this.debtAgreementRules.levels = levels;
      })
      .catch(() => {
        this.$alert.notifyAlert('Erro ao buscar informações, tente novamente mais tarde');
      })
      .finally(() => {
        this.$loader.hide();
      });
  },
  methods: {
    ...mapActions(['loadEnumsDebtAgreementRules', 'loadLevels']),
    createAgreementRule() {
      if (this.agreementRuleForm.validateForm()) {
        this.$loader.show();
        this.agreementRuleForm.get('installmentsLimit').ignoreOnGetRawValue = this.installmentsTypeIsInstitutionEval;
        DebtAgreementRulesService.create(this.agreementRuleForm.getRawValue())
          .then(({ data }) => {
            this.$alert.notifySuccess('Regra de acordo criada com sucesso.');
            this.$emit('agreement-rule-created', data);
          })
          .catch(() => {
            this.$alert.notifyAlert('Erro ao criar regra de acordo');
          })
          .finally(() => {
            this.$loader.hide();
          });
      }
    },
    checkMinAmountLowerThanMaxAmount() {
      if (this.agreementRuleForm.getValue('maximumAmount')) {
        this.agreementRuleForm.get('minimumAmount').lowerThan = this.agreementRuleForm.getValue('maximumAmount');
        this.agreementRuleForm.get('minimumAmount').validateField();
      } else {
        this.agreementRuleForm.get('minimumAmount').lowerThan = 2000;
        this.agreementRuleForm.get('minimumAmount').validateField();
      }
    },
  },
};
</script>
